// src/pages/financeiro/FinanceiroLancamentosPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import LayoutDesktop from "../../layouts/LayoutDesktop";

export default function FinanceiroLancamentosPage() {
  const { tema } = useTheme();
  const navigate = useNavigate();

  return (
    <LayoutDesktop tema={tema} titulo="Financeiro" subtitulo="Lancamentos">
      <section className="pc-card">
        <h2 style={{ marginTop: 0 }}>Lancamentos</h2>
        <p style={{ marginTop: 8, lineHeight: 1.5 }}>
          Tela central do financeiro para entradas e saídas. No MVP, os lançamentos são
          organizados por origem: Receitas, Contas a Pagar e Cartões de Crédito.
        </p>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
          <button type="button" className="pc-btn-secundario" onClick={() => navigate("/financeiro/receitas")}>
            Ir para Receitas
          </button>
          <button type="button" className="pc-btn-secundario" onClick={() => navigate("/financeiro/contas-pagar")}>
            Ir para Contas a Pagar
          </button>
          <button type="button" className="pc-btn-secundario" onClick={() => navigate("/financeiro/cartoes-credito")}>
            Ir para Cartões
          </button>
        </div>

        <ul style={{ marginTop: 14, lineHeight: 1.6 }}>
          <li>Registrar entrada e saída com data de competência e vencimento</li>
          <li>Relacionar lançamento com conta financeira e categoria</li>
          <li>Conciliação por status: pendente, pago/recebido, cancelado</li>
          <li>Filtro por período, conta, categoria e situação</li>
        </ul>
      </section>
    </LayoutDesktop>
  );
}
